<template>
  <div class="title-wrap">
    <div class="table-wrap">
      <div class="filter">
        <el-input placeholder="请输入标题包名称" suffix-icon="el-icon-search" @change="changeKey" v-model="searchStr"> </el-input>
      </div>
      <div class="table">
        <el-table :max-height="tableHeight" ref="table" :data="tableData" style="width: 100%">
          <el-table-column prop="groupName" label="标题包名称"> </el-table-column>
          <el-table-column prop="id" label="标题包ID"> </el-table-column>
          <el-table-column prop="assetCount" label="标题数量"> </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column>
          <el-table-column prop="operate" label="操作" align="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="deletePkg(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <self-pagination
          class="footer-page"
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getAssetGroupList, deleteAssetGroup } from "@/api/promotion-google.js";
export default {
  data() {
    return {
      searchStr: "",
      tableHeight: window.innerHeight - 210,
      pageData: {
        total: 10,
        size: 10,
        page: 1,
      },
      tableData: [],
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.getData();
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },

  methods: {
    changePage(page) {
      this.pageData.page = page;
      this.getData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getData();
    },
    changeKey() {
      this.pageData.page = 1;
      this.getData();
    },
    getData() {
      //查询标题包
      getAssetGroupList({
        groupName: this.searchStr,
        page: this.pageData.page,
        size: this.pageData.size,
        assetType: 3,
        platType: 5,
      }).then((res) => {
        if (res.code === "0000") {
          this.pageData.total = res.data.total;
          this.tableData = res.data.list;
        }
      });
    },
    refresh() {
      this.tableHeight = window.innerHeight - 210;
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    deletePkg(data) {
      this.$confirm("确定删除该标题包?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAssetGroup({ id: data.id }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "标题包删除成功",
                type: "success",
              });
              this.pageData.page = 1;
              this.getData();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.title-wrap {
  padding: 16px;
  .table-wrap {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .filter {
      width: 200px;
    }
    .table {
      margin-top: 20px;
      width: 100%;
    }
  }
  .modal-table {
    margin-top: 12px;
    /deep/ .el-table__cell {
      padding: 4px;
    }
    /deep/ th {
      height: 35px;
    }
  }
}
</style>
